import FVector from '@data/geometry/FVector';
import { SensorData } from 'Simulations/SensorPoint';

export function computeAverageDirectionFromSensors(sensors: SensorData[]): FVector {
    const directions = sensors.filter((sensor) => sensor.getScalarValue() !== 0).map((sensor) => sensor.getVectorialResult());
    if (!directions.length) return new FVector();
    return directions.reduce((acc, dir) => acc.add(dir), new FVector()).normalize();
}
